let routes = [
    {
        path: '/store/info',
        name: 'store-app-center-info',
        meta: {
            title: '应用中心详情',
            company: true
        },
        component: () => import('../views/store/app-center-info')
    }, { //增值服务 - 详情
        path: '/store/appreciation-service-info',
        name: 'store-appreciation-service-info',
        meta: {
            title: '增值服务详情',
            company: true
        },
        component: () => import('../views/store/appreciation-service-info')
    }, {
        path: '/store/pay-choose',
        name: 'store-pay-choose',
        meta: {
            title: '支付订单',
            company: true
        },
        component: () => import('../views/store/pay-choose')
    }, {
        path: '/store/pay-end',
        name: 'store-pay-end',
        meta: {
            title: '正在配置服务',
            company: true
        },
        component: () => import('../views/store/pay-end')
    }, {
        path: '/store/xufei',
        name: 'store-xufei',
        meta: {
            title: '续费',
            company: true
        },
        component: () => import('../views/store/xufei')
    }, {
        path: '/store/pay-preview',
        name: 'store-pay-preview',
        meta: {
            title: '确认订单',
            company: true
        },
        component: () => import('../views/store/pay-preview')
    }];

export default routes;
